import type { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@/meta/common";

const supplierManagementRouter: RouteRecordRaw[] = [
    {
        path: "/supplierManagement",
        name: "SupplierManagement",
        component: () => import("@/layouts/index.vue"),
        meta: {
            title: "供应商管理"
        },
        children: [
            {
                path: "enterpriseManage",
                name: "EnterpriseManage",
                component: () => import("@/views/pages/tradeManage/enterpriseManage/index.vue"),
                meta: {
                    title: "供应商管理",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_SUPPLIER_R"
                        },
                        {
                            label: "查看",
                            value: "ROLE_SUPPLIER_DEAL"
                        }
                    ]
                }
            },
            {
                path: "enterpriseManage/detail",
                name: "EnterpriseManageDetail",
                component: () => import("@/views/pages/tradeManage/enterpriseManage/detail.vue"),
                meta: {
                    title: "供应商详情",
                    hidden: true,
                    activeMenu: "EnterpriseManage",
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_SUPPLIER_R"
                        },
                        {
                            label: "查看",
                            value: "ROLE_SUPPLIER_DEAL"
                        }
                    ]
                }
            },
            {
                path: "enterpriseManage/add",
                name: "EnterpriseManageAdd",
                component: () => import("@/views/pages/tradeManage/enterpriseManage/form.vue"),
                meta: {
                    title: "新增供应商",
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "EnterpriseManage",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_SUPPLIER_DEAL"
                        }
                    ]
                }
            },
            {
                path: "enterpriseManage/edit",
                name: "EnterpriseManageEdit",
                component: () => import("@/views/pages/tradeManage/enterpriseManage/form.vue"),
                meta: {
                    title: "修改供应商",
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "EnterpriseManage",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_SUPPLIER_DEAL"
                        }
                    ]
                }
            },
            {
                path: "cliqueManage",
                name: "CliqueManage",
                component: () => import("@/views/pages/tradeManage/cliqueManage/index.vue"),
                meta: {
                    title: "集团管理",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_SUPPLIER_R"
                        },
                        {
                            label: "查看",
                            value: "ROLE_SUPPLIER_DEAL"
                        }
                    ]
                }
            }
        ]
    }
];

export default supplierManagementRouter;
